import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrCorModel extends PadraoModel {
  recurso = 'usadosbr/cores';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Cores Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
